import React from "react";

/**
 * Reusable section eyebrow/badge — pill shaped, cyan outline,
 * dark transparent background, uppercase mono text.
 * Used as the single, consistent visual treatment for every
 * section label across the landing page.
 */
const SectionBadge = ({ children, withDot = true, icon: Icon, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 whitespace-nowrap px-3.5 py-1.5 rounded-full border border-[#1dc7e9]/30 bg-[#1dc7e9]/10 text-[#1dc7e9] text-[10.5px] font-bold uppercase tracking-[0.22em] mono ${className}`}
    data-testid="section-badge"
  >
    {Icon ? (
      <Icon size={12} strokeWidth={2} />
    ) : withDot ? (
      <span className="w-1.5 h-1.5 rounded-full bg-[#1dc7e9] animate-pulse" />
    ) : null}
    {children}
  </span>
);

export default SectionBadge;
